import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import Select from "react-select";
import { WebEngage, GA } from "../../../integrations";
import { PAGE_TYPE } from "../../../constants";
import {
  fetchAllCandidatesList,
  fetchConstituency,
  fetchCandidatesPageList,
  fetchSearchCandidatesList,
  fetchPartyList,
  fetchpartyWiseCandidatesList,
  fetchTeamPartyList
} from "../../../api";
import styles from "./styles.m.css";
import { Icon } from "../../atoms/icon";
import assetify from "@quintype/framework/assetify";
import Carousel from "../../atoms/carousel";
import loader from "../../../../assets/images/loader.gif";
import translate from "../../../../assets/images/translate.png";
import { VikatanAsidebar } from "../../rows/ad-free";

class AutoSelectComponent extends React.Component {
  logChange = val => {
    const { SelectedValue } = this.props;
    SelectedValue(val.value);
  };

  render() {
    const { options, className } = this.props;
    return <Select className={styles[className]} options={options} onChange={this.logChange} />;
  }
}

AutoSelectComponent.propTypes = {
  options: PropTypes.array,
  SelectedValue: PropTypes.func,
  className: PropTypes.string
};
const CandidatePage = ({ data }) => {
  const [constituency, setConstituency] = useState([]);
  const [candidatesList, setCandidatesList] = useState([]);
  const [disabledPrev, setdisabledPrev] = useState(false);
  const [disabledNext, setdisabledNext] = useState(true);
  const [thoguthigal, setthoguthigal] = useState([]);
  const [indexValue, setIndex] = useState(1);
  const [Vetpalargal, setVetpalargal] = useState([]);
  const [ShowLoader, setShowLoader] = useState(false);
  const [ShowFilteredData, setShowFilteredData] = useState(false);
  const inputField = React.useRef(null);
  const [Parties, setParties] = useState([]);
  const [thoguthiId, setthoguthiId] = useState("");
  const [partyId, setpartyId] = useState("");
  const [TeamPartyId, setTeamPartyId] = useState("");
  const [Searchvalue, setSearchvalue] = useState("");
  const [showErroMessage, setshowErroMessage] = useState(false);
  const [PartyTeam, setPartyTeam] = useState([]);
  const [ThogidhuVal, setThogidhuVal] = useState("");
  const [TeamPartyVal, setTeamPartyVal] = useState("");
  const [KatchigalVal, setKatchigalVal] = useState("");

  useEffect(() => {
    fetchCandidatesPageList(indexValue)
      .then(res => {
        const conRes = get(res, ["data", "items"]);

        setVetpalargal(conRes);
      })
      .catch(console.error);
    fetchConstituency()
      .then(res => {
        const conRes = get(res, ["data", "items"]);
        setConstituency(conRes);
      })
      .catch(console.error);
    fetchPartyList()
      .then(res => {
        const conRes = get(res, ["data", "items"]);
        setParties(conRes);
      })
      .catch(console.error);
    fetchTeamPartyList()
      .then(res => {
        const conRes = get(res, ["data", "items"]);
        setPartyTeam(conRes);
      })
      .catch(console.error);

    fetchAllCandidatesList()
      .then(res => {
        const resData = get(res, ["data", "items"]);
        setCandidatesList(resData);
      })
      .catch(console.error);
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.CONSTITUENCY_PAGE, { collection: data.collection });
  }, []);

  const allContOp =
    constituency &&
    constituency.map(item => {
      const objItem = {};
      objItem.label = `${item.area} (${item.area_en})`;
      objItem.value = item.party_id;
      return objItem;
    });
  allContOp.unshift({ label: "All constituency", value: "All" });

  const partyEntries = Object.entries(Parties);
  const AllParties =
    partyEntries && partyEntries.length > 0
      ? partyEntries.map((item, i) => {
          const objItem = {};
          objItem.label = item[1];
          objItem.value = item[0];
          return objItem;
        })
      : [];

  const TeampartyEntries = Object.entries(PartyTeam);
  const AllTeampartyEntries =
    TeampartyEntries && TeampartyEntries.length > 0
      ? TeampartyEntries.map((item, i) => {
          const objItem = {};
          objItem.label = item[1];
          objItem.value = item[0];
          return objItem;
        })
      : [];

  const filteroverallData = candidatesList;

  function handleChangeThoguthi(e) {
    setThogidhuVal(e);
    let value = e.value;
    if (value && value !== "All") {
      setShowFilteredData(value);
      setthoguthiId(value);
      setShowLoader(true);
      setSearchvalue("");
      fetchpartyWiseCandidatesList(value, partyId, TeamPartyId)
        .then(res => {
          const conRes = get(res, ["data", "items"]);
          setthoguthigal(conRes);
          setShowLoader(false);
          if (conRes.length === 0) {
            setshowErroMessage(true);
          } else {
            setshowErroMessage(false);
          }
        })
        .catch(console.error);
    }

    if (value === "All") {
      setSearchvalue("");
      setShowFilteredData(false);
      setshowErroMessage(false);
      setShowLoader(true);
      setpartyId("");
      setthoguthiId("");

      fetchCandidatesPageList(indexValue)
        .then(res => {
          const conRes = get(res, ["data", "items"]);
          setVetpalargal(conRes);
          setShowLoader(false);
        })
        .catch(console.error);
    }
  }

  function handleChangeKatchigal(e) {
    setKatchigalVal(e);
    let value = e.value;
    setSearchvalue("");
    setShowFilteredData(value);
    setpartyId(value);
    setShowLoader(true);
    fetchpartyWiseCandidatesList(thoguthiId, value, TeamPartyId).then(res => {
      const conRes = get(res, ["data", "items"]);
      setthoguthigal(conRes);
      setShowLoader(false);
      if (conRes.length === 0) {
        setshowErroMessage(true);
      } else {
        setshowErroMessage(false);
      }
    });
  }

  function clearFilters() {
    setThogidhuVal(null);
    setTeamPartyVal(null);
    setKatchigalVal(null);
    setSearchvalue("");
    setSearchvalue("");
    setShowFilteredData(false);
    setshowErroMessage(false);
    setShowLoader(true);
    setTeamPartyId();
    setpartyId();
    setthoguthiId();

    fetchCandidatesPageList(indexValue)
      .then(res => {
        const conRes = get(res, ["data", "items"]);
        setVetpalargal(conRes);
        setShowLoader(false);
      })
      .catch(console.error);
  }

  function handleChangeTeamParty(e) {
    setSearchvalue("");
    setTeamPartyVal(e);
    let value = e.value;
    setShowFilteredData(value);
    setTeamPartyId(value);
    setShowLoader(true);
    fetchpartyWiseCandidatesList(thoguthiId, partyId, value).then(res => {
      const conRes = get(res, ["data", "items"]);
      setthoguthigal(conRes);
      setShowLoader(false);
      if (conRes.length === 0) {
        setshowErroMessage(true);
      } else {
        setshowErroMessage(false);
      }
    });
  }

  function handleChangeSearch(e) {
    var specials = /[*|":<>[\]{}!`\\()';@&$ 0-9]/;
    if (!specials.test(e.target.value)) {
      setSearchvalue(e.target.value);
    }
    if (e.target.value.length >= 3) {
      setShowLoader(true);
      setShowFilteredData(true);
      let SearchId = e.target.value;
      fetchSearchCandidatesList(SearchId).then(res => {
        const conRes = get(res, ["data", "items"]);
        setthoguthigal(conRes);
        setShowLoader(false);
        if (conRes.length === 0) {
          setshowErroMessage(true);
        } else {
          setshowErroMessage(false);
        }
      });
    } else {
      if (e.target.value.length <= 0) {
        setShowFilteredData(false);
        setpartyId("");
        setthoguthiId("");
        fetchCandidatesPageList(indexValue)
          .then(res => {
            const conRes = get(res, ["data", "items"]);
            setVetpalargal(conRes);
            setShowLoader(false);
          })
          .catch(console.error);
      }
    }
  }

  function togglePrev() {
    window.scrollTo({
      top: inputField.current.offsetTop + 260,
      behavior: "smooth"
    });
    setdisabledPrev(true);
    let index = indexValue - 1;
    if (index === 1) {
      setdisabledPrev(false);
    }
    if (index < 23) {
      setdisabledNext(true);
    }
    setIndex(index);
    fetchCandidatesPageList(index).then(res => {
      const conRes = get(res, ["data", "items"]);
      setVetpalargal(conRes);
      setShowLoader(false);
    });
  }
  function toggleNext() {
    window.scrollTo({
      top: inputField.current.offsetTop + 260,
      behavior: "smooth"
    });
    let index = indexValue + 1;
    if (index > 22) {
      setdisabledNext(false);
    } else {
      setdisabledNext(true);
    }
    setIndex(index);
    setdisabledPrev(true);
    fetchCandidatesPageList(index).then(res => {
      const conRes = get(res, ["data", "items"]);
      setVetpalargal(conRes);
      setShowLoader(false);
    });
  }

  let ThoguthigalEntries = "";
  let entries = "";
  let VetpalargalEntries = "";
  if (thoguthigal) {
    ThoguthigalEntries = Object.entries(thoguthigal);
  }
  if (filteroverallData) {
    entries = Object.entries(filteroverallData);
  }
  if (Vetpalargal) {
    VetpalargalEntries = Object.entries(Vetpalargal);
  }

  const slidesWithClasses =
    VetpalargalEntries !== 0
      ? VetpalargalEntries.map((slide, idx) => {
          const conname = get(slide, [1, 0, "thokuthi_name"]);
          return (
            <div className={styles["canditate-div"]} key={"slide-" + idx}>
              <h1 className={styles["canditate-title"]}>{conname}</h1>
              <div className={styles["candiate-grid"]}>
                {slide[1].map((item, index) => {
                  return (
                    <div className={styles["box-div"]} key={"slide-" + index}>
                      <div className={styles["title"]}>
                        <h1>{item.team_name}</h1>
                      </div>
                      <div className={styles["other-img"]}>
                        {item.star_candidate !== 0 ? <Icon type="star" className={styles["star-icon"]} /> : ""}
                        <img src={`${item.candidate_image}`} className={styles["mem-img"]} />
                      </div>
                      <h1>
                        {item.candidate_name} <span>({item.party_name})</span>
                      </h1>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })
      : "No candidates match your search criteria. Please search again!";

  const slidesFromFilter =
    ThoguthigalEntries !== 0 &&
    ThoguthigalEntries.map((slide, idx) => {
      return (
        <div className={styles["box-div"]} key={"slide-" + idx}>
          <div className={styles["title"]}>
            <h1>{slide[1].team_name}</h1>
          </div>
          <div className={styles["other-img"]}>
            {slide[1].star_candidate !== 0 ? <Icon type="star" className={styles["star-icon"]} /> : ""}
            <img
              // eslint-disable-next-line max-len
              src={`${slide[1].candidate_image}`}
              className={styles["mem-img"]}
            />
          </div>
          <h1>
            {slide[1].candidate_name} <span>({slide[1].party_name})</span>
          </h1>
          <p className={styles["thoguthi-name"]}>
            <Link
              aria-label={`இங்கு க்ளிக் செய்க`}
              // eslint-disable-next-line max-len
              href={`/election-2021/constituency/${ShowFilteredData}-assembly-constituency-elections-2021-updates`}
            >
              {slide[1].thokuthi_name}
            </Link>
          </p>
        </div>
      );
    });

  const title = get(constituency, ["area"], null);

  const slidesWithCandidates =
    entries !== 0 &&
    entries.filter(i => i[1].star_candidate !== 0).map((slide, idx) => {
      return (
        <div className={styles["box-div"]} key={"slide-" + idx}>
          <div className={styles["title"]}>
            <h1>{slide[1].team_name}</h1>
          </div>
          <div className={styles["other-img"]}>
            {slide[1].star_candidate !== 0 ? <Icon type="star" className={styles["star-icon"]} /> : ""}
            <img
              // eslint-disable-next-line max-len
              src={`${slide[1].candidate_image}`}
              className={styles["mem-img"]}
            />
          </div>
          <h1>
            {slide[1].candidate_name} <span>({slide[1].party_name})</span>
          </h1>
        </div>
      );
    });

  const vetpalarkalOption = entries.length !== 0 && (
    <div className={styles["other-members-wrapper"]}>
      <h2>நட்சத்திர வேட்பாளர்கள் </h2>
      <div className={styles["other-members-slider"]}>
        <Carousel
          className={`${styles["other-members-slider"]}`}
          options={{
            autoplay: 3000,
            type: "carousel",
            perView: 4,
            gap: 80,
            breakpoints: {
              320: {
                perView: 1.5,
                gap: 10
              },
              767: {
                perView: 1.5,
                gap: 10
              },
              991: {
                perView: 4,
                gap: 40
              }
            }
          }}
          renderCenterLeftControls={({ previousSlide }) => {
            return null;
          }}
          renderCenterRightControls={({ nextSlide }) => {
            return null;
          }}
          renderBottomCenterControls={({ currentSlide, goToSlide }) => {
            return null;
          }}
        >
          {slidesWithCandidates}
        </Carousel>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
        <div />
        <div className="page-content infinity-page">
          <div className={`container ${styles["story-grid"]}`}>
            <div className={`${styles["main-container"]}`}>
              <ul className={styles["breadcrumb-wrapper"]}>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link aria-label={`breadcrumb`} href="/">
                    முகப்பு
                  </Link>
                </li>
                <li className={`${styles["breadcrumb"]}`}>
                  <Link aria-label={`breadcrumb`} href="/tamil-nadu-election-candidates-list-2021">
                    தமிழ்நாடு வேட்பாளர்கள் பட்டியல்
                  </Link>
                </li>
              </ul>
              <div className={styles["districk-dropdownnn"]} ref={inputField}>
                <h1>{title}</h1>
                {vetpalarkalOption}
                <div className={styles["form-grid"]}>
                  <div className={styles["form-content"]}>
                    <div className={styles["form"]}>
                      <div>
                        <label>தொகுதி / வேட்பாளர்கள்</label>
                        <div className={styles["search-field"]}>
                          <input
                            className="districk"
                            type="text"
                            value={Searchvalue}
                            onChange={event => handleChangeSearch(event)}
                          />
                          <div className={styles["form-icons"]}>
                            <Icon type="search" className={styles["search"]} />
                            <img alt="Translate" src={assetify(translate)} className={styles["translate"]} />
                          </div>
                        </div>
                      </div>
                      <div className={styles["or"]}>OR</div>

                      <div>
                        <label>சட்டமன்றத் தொகுதி</label>
                        <Select
                          className="districk"
                          onChange={e => handleChangeThoguthi(e)}
                          options={allContOp}
                          value={ThogidhuVal}
                        />
                      </div>
                      <div>
                        <label>கூட்டணி கட்சிகள்</label>

                        <Select
                          className="districk"
                          onChange={e => handleChangeTeamParty(e)}
                          options={AllTeampartyEntries}
                          value={TeamPartyVal}
                        />
                      </div>
                      <div>
                        <label>கட்சிகள்</label>

                        <Select
                          className="districk"
                          onChange={e => handleChangeKatchigal(e)}
                          options={AllParties}
                          value={KatchigalVal}
                        />
                      </div>
                      <div>
                        <button type="button" className={styles["button"]} onClick={clearFilters}>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    {ShowLoader ? (
                      <img alt="Vikatan" src={assetify(loader)} className={styles["loader"]} />
                    ) : ShowFilteredData ? (
                      <h2 className={styles["filter-canditate"]}>{slidesFromFilter}</h2>
                    ) : (
                      <h2 className={styles["third-tab-details"]}>{slidesWithClasses}</h2>
                    )}
                  </div>
                  {showErroMessage ? (
                    <div className="error-msg">No candidates match your search criteria. Please search again! </div>
                  ) : (
                    ""
                  )}
                </div>
                {!ShowFilteredData && (
                  <div className={styles["pagination-btns"]}>
                    {disabledPrev && (
                      <button onClick={togglePrev} disabled={!disabledPrev}>
                        Previous
                      </button>
                    )}
                    {disabledNext && <button onClick={toggleNext}>Next</button>}
                  </div>
                )}
              </div>
            </div>

            <aside className={styles.sidebar}>
              <VikatanAsidebar />
            </aside>
          </div>
        </div>

        <div />
      </div>
    </React.Fragment>
  );
};
export { CandidatePage };

CandidatePage.propTypes = {
  data: PropTypes.shape()
};
